/**
 * The endpoint the Cognito SDK should address the user pool at, derived from the issuer that
 * tenant-api publishes on the tenant record.
 *
 * `amazon-cognito-identity-js` otherwise assumes AWS: it builds
 * `https://cognito-idp.<region>.amazonaws.com/` from the region embedded in the pool id, and there
 * is no way to reach a pool hosted anywhere else. In production the tenant's issuer is
 * `https://cognito-idp.<region>.amazonaws.com/<poolId>`, whose origin is exactly that same URL — so
 * passing this through is a no-op there. It only takes effect when the pool genuinely is not on
 * AWS, which is the one thing the SDK cannot infer.
 *
 * Returns `undefined` when there is no usable issuer, so the caller can omit `endpoint` entirely
 * and leave the SDK's own default in place.
 */
export const cognitoEndpoint = (issuer?: string): string | undefined => {
  if (!issuer) return undefined;
  try {
    return new URL(issuer).origin;
  } catch {
    // A malformed issuer must never break sign-in — fall back to the SDK default.
    return undefined;
  }
};
